// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");

function UploadProgressIndicator(props) {
  let __progress = props.progress;
  let progress = __progress !== undefined ? __progress : 0;
  let circumference = 2 * Math.PI * 12;
  let pct = progress / 100;
  let dashoffset = circumference * (1 - pct);
  return JsxRuntime.jsxs("svg", {
    children: [
      JsxRuntime.jsx("circle", {
        cx: "15",
        cy: "15",
        fill: "none",
        r: "12",
        stroke: "#dddddd",
        strokeWidth: "3"
      }),
      JsxRuntime.jsx("circle", {
        cx: "15",
        cy: "15",
        fill: "none",
        r: "12",
        stroke: "#28618d",
        strokeDasharray: circumference.toString(),
        strokeDashoffset: dashoffset.toString(),
        strokeLinecap: "square",
        strokeWidth: "3"
      })
    ],
    className: "transform -rotate-90",
    height: "30",
    width: "30",
    viewBox: "0 0 30 30"
  });
}

let make = UploadProgressIndicator;

exports.make = make;
/* react/jsx-runtime Not a pure module */
